<template>
    <div>
        <div v-if="historyInfo && historyInfo.items && historyInfo.items.length > 0">
            <h4>Current Amount: {{currentAmount}}</h4>
            <br>
            
            <table class="amount-history-table">
                <tr>
                    <th width="40%" align="left">Date Time</th>
                    <th width="20%" align="right">Original</th>
                    <th width="20%" align="right">New</th>
                </tr>
                <tr v-for="(item, index) in historyInfo.items" :key="'history' + index">
                    <td width="40%" align="left">{{$_getDateTimeFormat(item.changeTime)}} by {{(item.user||{}).userName || '-'}}</td>
                    <td width="20%" align="right">{{item.originalValue}}</td>
                    <td width="20%" align="right">
                        <div>
                            <span>{{item.newValue}}</span>
                            <div v-html="getDifference(item)"></div>
                        </div>
                    </td>
                </tr>
            </table>
            
            <el-pagination
                :hide-on-single-page="false"
                :page-size="maxResultCount"
                :total="historyInfo.totalCount"
                @current-change="handleCurrentPageChange($event)"
                layout="prev, pager, next">
            </el-pagination>
        </div>
        <div v-else class="empty-history-container">
            <p>Amount History Not Found</p>
        </div>
    </div>
</template>

<script>
    import { subjectGetAmountChangeHistory } from '@/api/subject'

    export default {
        props: {
            detailInfo: {
                type: Object
            },
            infoSidebarId: {
                type: Number | String
            },
            currentAmount: {
                type: String
            }
        },
        data() {
            return {
                currentPage: 1,
                skipCount: 0,
                maxResultCount: 10,
                newHistoryInfo: null
            }
        },
        computed: {
            apiParams(){
                var fix_params = {
                    'SkipCount': this.skipCount,
                    'MaxResultCount': this.maxResultCount,
                }
                var params = Object.assign(fix_params);
                return params;
            },
            historyInfo() {
                if(this.newHistoryInfo) {
                    let his_info = this.newHistoryInfo.items.map(item => {
                        let diff_amount = item.originalValue - item.newValue
                        if(diff_amount >= 0) {
                            item.usedAmount = diff_amount
                            item.topUpAmount = null
                        }
                        else {
                            item.topUpAmount = diff_amount * -1
                            item.usedAmount = null
                        }

                        return {...item}
                    })
                    return {...this.newHistoryInfo, 'items': his_info}
                }
            }
        },
        methods: {
            async getDetails() {
                this.newHistoryInfo = await subjectGetAmountChangeHistory({ 
                    'SubjectId': this.infoSidebarId, 
                    'Sorting': 'changeTime asc',  
                    ...this.apiParams
                })
            },
            getDifference(item) {
                 let diff_amount = item.originalValue - item.newValue
                if(diff_amount >= 0) {
                    return `<span class='used-amount-value'>(- ${this.$_roundOfDecimal(diff_amount, 2)})</span>`
                }
                else {
                    diff_amount = diff_amount * -1
                    return `<span class='topup-amount-value'>(+ ${this.$_roundOfDecimal(diff_amount, 2)})</span>`
                }
            },
            handleCurrentPageChange(val){
                this.currentPage = val || 1;
                this.skipCount = this.currentPage * this.maxResultCount - this.maxResultCount;
                this.getDetails();
            }
        },
        watch: {
            infoSidebarId: {
                immediate: true,
                handler(newVal, oldVal) {
                    this.getDetails()
                },
            },
        }
    }
</script>

<style lang="css" scoped>
.amount-history-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.amount-history-table th{
    border: 1px solid #ddd;
    padding: 8px;
}
.amount-history-table td{
    border: 1px solid #ddd;
    padding: 8px;
}
.empty-history-container {
    height: 200px;
    border: 1px dashed var(--section-line-grey);
    display: flex;
    justify-content: center;
    align-items: center;
}
.empty-history-container p {
    color: var(--description-grey);
}

</style>
<style lang="css">
.topup-amount-value {
    color: green;
    font-size: 11px;
}
.used-amount-value {
    color: red;
    font-size: 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/amountHistoryTable.vue